import { resolveFlags, type FlagLayers, type FlagValues, type ResolvedFlags } from '@core/access/flags';

import type { ScopeNode } from './scopes';
import type { SettingsDocument } from './settings.model';

export interface ShippedFlags {
  environment: FlagValues;
  deployment: FlagValues;
  deploymentScopes: Record<string, FlagValues>;
}

/**
 * One level's flag overrides: the deployment file's for that scope, with the
 * saved settings over them. Settings win because they are the deliberate,
 * recorded change; the file's scopes are how those changes reach a host
 * before the Settings API does.
 */
export function scopeFlagValues(shipped: ShippedFlags, document: SettingsDocument, scopeId: string): FlagValues {
  return { ...shipped.deploymentScopes[scopeId], ...document.scopes[scopeId]?.flags };
}

export function flagLayersFor(shipped: ShippedFlags, document: SettingsDocument, chain: readonly ScopeNode[]): FlagLayers {
  return {
    environment: shipped.environment,
    deployment: shipped.deployment,
    scopes: chain.map((node) => ({ id: node.id, values: scopeFlagValues(shipped, document, node.id) }))
  };
}

/** The flags in force at the bottom of `chain`. */
export function resolveFlagsAt(shipped: ShippedFlags, document: SettingsDocument, chain: readonly ScopeNode[]): ResolvedFlags {
  return resolveFlags(flagLayersFor(shipped, document, chain));
}
